import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "avatar bg-primary text-white"
}
const _hoisted_2 = { class: "ms-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-header bg-light fw-semibold py-2" }, "Konto", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CDropdownToggle = _resolveComponent("CDropdownToggle")!
  const _component_BIconShieldLockFill = _resolveComponent("BIconShieldLockFill")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BIconLockFill = _resolveComponent("BIconLockFill")!
  const _component_CDropdownMenu = _resolveComponent("CDropdownMenu")!
  const _component_CDropdown = _resolveComponent("CDropdown")!

  return (_openBlock(), _createBlock(_component_CDropdown, { variant: "nav-item" }, {
    default: _withCtx(() => [
      _createVNode(_component_CDropdownToggle, {
        placement: "bottom-end",
        class: "p-0 d-flex align-items-center",
        caret: true
      }, {
        default: _withCtx(() => [
          (this.$store.state.auth.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(this.$store.state.auth.name
            .split(" ")
            .map((item) => item.charAt(0))
            .join("")
            .toUpperCase()), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, _toDisplayString(this.$store.state.auth.name), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_CDropdownMenu, { class: "pt-0" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_router_link, {
            to: { name: 'PasswordChange' },
            class: _normalizeClass(["dropdown-item d-flex align-items-center", {
          active: _ctx.$router.currentRoute.value.name === 'PasswordChange',
        }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BIconShieldLockFill, { class: "me-2" }),
              _createTextVNode(" Zmiana hasła ")
            ]),
            _: 1
          }, 8, ["class"]),
          _createElementVNode("a", {
            href: "#",
            class: "dropdown-item d-flex align-items-center",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _createVNode(_component_BIconLockFill, { class: "me-2" }),
            _createTextVNode(" Wyloguj")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}